import React from 'react';
import { Form, Input, Select, Typography, InputNumber, Switch, Row, Col } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const WaitNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Wait Type" name="waitType" initialValue={config.waitType || 'fixed_delay'} rules={[{ required: true }]}>
        <Select>
          <Option value="fixed_delay">Fixed Delay</Option>
          <Option value="condition">Wait for Condition</Option>
          <Option value="external_signal">External Signal</Option>
          <Option value="rate_limit">Rate Limiting</Option>
        </Select>
      </Form.Item>

      {config.waitType === 'fixed_delay' && (
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label="Delay Amount" name="delayAmount" initialValue={config.delayAmount || 5} rules={[{ required: true }]}>
              <InputNumber min={0.1} style={{ width: '100%' }} placeholder="Delay value" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Time Unit" name="timeUnit" initialValue={config.timeUnit || 'seconds'}>
              <Select>
                <Option value="milliseconds">Milliseconds</Option>
                <Option value="seconds">Seconds</Option>
                <Option value="minutes">Minutes</Option>
                <Option value="hours">Hours</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      )}

      {config.waitType === 'condition' && (
        <>
          <Form.Item label="Condition Expression" name="condition" initialValue={config.condition || ''} rules={[{ required: true }]}>
            <Input placeholder="e.g., globalVariable.ready === true" />
          </Form.Item>
          <Form.Item label="Check Interval (seconds)" name="checkInterval" initialValue={config.checkInterval || 1}>
            <InputNumber min={0.1} style={{ width: '100%' }} placeholder="How often to check condition" />
          </Form.Item>
        </>
      )}

      {config.waitType === 'external_signal' && (
        <Form.Item label="Signal Name" name="signalName" initialValue={config.signalName || ''} rules={[{ required: true }]}>
          <Input placeholder="Name of external signal to wait for" />
        </Form.Item>
      )}

      {config.waitType === 'rate_limit' && (
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label="Max Rate" name="maxRate" initialValue={config.maxRate || 10} rules={[{ required: true }]}>
              <InputNumber min={1} style={{ width: '100%' }} placeholder="Requests per period" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Time Period" name="timePeriod" initialValue={config.timePeriod || 'per_second'}>
              <Select>
                <Option value="per_second">Per Second</Option>
                <Option value="per_minute">Per Minute</Option>
                <Option value="per_hour">Per Hour</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      )}

      <Form.Item label="Max Wait Time (seconds)" name="maxWaitTime" initialValue={config.maxWaitTime || 300}>
        <InputNumber min={1} style={{ width: '100%' }} placeholder="Maximum time to wait" />
      </Form.Item>

      <Form.Item label="Timeout Behavior" name="timeoutBehavior" initialValue={config.timeoutBehavior || 'continue'}>
        <Select>
          <Option value="continue">Continue Anyway</Option>
          <Option value="error">Raise Error</Option>
          <Option value="skip">Skip to End</Option>
        </Select>
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Show Progress" name="showProgress" initialValue={config.showProgress !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Interruptible" name="interruptible" initialValue={config.interruptible !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Wait Node:</strong><br/>
          • Pauses workflow execution<br/>
          • <strong>Fixed Delay:</strong> Waits for specified time<br/>
          • <strong>Condition:</strong> Waits until expression becomes true<br/>
          • <strong>External Signal:</strong> Waits for manual trigger<br/>
          • <strong>Rate Limit:</strong> Enforces processing rate limits
        </Text>
      </div>
    </>
  );
};

export default WaitNodeProperties;